import React from "react";
import PropTypes from "prop-types";
import StyledFilterPriceRadio from "./FilterPriceRadio.styled";
import { filterRangePT } from "../../config/prop-types";

const FilterPriceRadio = React.memo(props => {
  const { range, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterPriceRadio className={`filter-product-price__radio ${checked && "is-checked"}`}>
      <svg className="filter-product-type__radio__svg-left" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="null" d="m23.96975,0.04124l-16.49031,0l0,2.89404l-0.28414,0l0.28414,0.34173l0,4.6027l-2.27313,0l0,4.36776l-2.85155,0l0,3.60954l-2.28327,0l0,5.42499l2.02958,0l0,3.01151l10.5132,0l0,-0.29902l11.35548,0"/></svg>

      <input disabled={disabled} checked={checked} onChange={() => checkFilter(range.id.toString(), range.value[0], range.value[1])} type="radio" />
      <span className="filter-product-price__radio__custom"></span>
      <span className="t-body-small filter-product-price__radio__copy">{range.name}</span>

      <svg className="filter-product-type__radio__svg-right" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke="null" d="m-0.12938,23.95877l18.06,0l0,-10.39136l4.12,0l0,-4.05412l1.93,0l0,-9.48452l-6.05,0l-17.9,0"/></svg>
    </StyledFilterPriceRadio>
  );
});

FilterPriceRadio.propTypes = {
    range: filterRangePT.isRequired,
    checkFilter: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default FilterPriceRadio;